import {LiveReducer, ReducerFromState} from "../../../@types/reducers";
import {AlertLiveObject} from "../../../@types/response";

export const getLiveAlerts = (state: ReducerFromState<LiveReducer>): Array<AlertLiveObject> => state.live.alerts;
